type TClasses = {
  [key: string]: boolean;
};

function getCssClasses(classes: TClasses) {
  return Object.keys(classes)
    .reduce((acc, classItem) => {
      if (classes[classItem]) {
        return `${acc} ${classItem}`;
      }
      return acc;
    }, "")
    .trim();
}

export default getCssClasses;
